// matches the styling of the internal ActionButton component (which does not support the component/to props)
export const actionButtonSx = { paddingLeft: '6px', paddingRight: '6px', minWidth: '0' }
